/**
 * Resilient Scaffolder API Factory
 *
 * This module simply re-exports the default ScaffolderClient.
 * The error suppression is handled by intercepting error notifications
 * at the application level via the AlertDisplay component customization.
 *
 * Future enhancement: Could add retry logic here if needed.
 */

import { scmIntegrationsApiRef } from '@backstage/integration-react';

import { scaffolderApiRef } from '@backstage/plugin-scaffolder-react';
import {
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { ScaffolderClient } from '@backstage/plugin-scaffolder-common';

/**
 * Standard scaffolder API factory
 * Error handling is managed at the app level
 */
export const resilientScaffolderApiFactory = createApiFactory({
  api: scaffolderApiRef,
  deps: {
    discoveryApi: discoveryApiRef,
    identityApi: identityApiRef,
    fetchApi: fetchApiRef,
    scmIntegrationsApi: scmIntegrationsApiRef,
  },
  factory: ({ discoveryApi, identityApi, fetchApi, scmIntegrationsApi }) =>
    new ScaffolderClient({
      discoveryApi,
      identityApi,
      fetchApi,
      scmIntegrationsApi,
    }),
});
